const leaseAgreementUnsupportedStates = ['VI', 'PR', 'GU', 'AS', 'MP'];

module.exports = leaseAgreementUnsupportedStates;
